import React, { useState, useEffect, useRef } from "react";
import CarePlans from "./CarePlans";
import CSSRS from "./assessments/CSSRS";
import CSSRS2 from "./assessments/CSSRS2";
import { getFormContainersAndVersions } from "./services/soar";
import { getFormAssessment } from "./../scripts/helperScripts";

import moment from "moment";

const Assessments = ({
  contactID,
  carePlans,
  updateCarePlans,
  clientProgram,
}) => {
  // const [token, setToken] = useState("");
  // const [opeekaPerson, setOpeekaPerson] = useState();
  const [formsInfo, setFormsInfo] = useState();
  // const [opData, setOpData] = useState();
  // const [reload, setReload] = useState(false);
  const isMountedRef = useRef(true);
  // const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  // let modules = [];
  const assessmentsToShow = clientProgram["unit.sor_safyportalconfig"]
    ? JSON.parse(clientProgram["unit.sor_safyportalconfig"])["assessments"]
    : [];
  const validUsers = () => {
    return true;

    // if (safyInfo) {
    //   const user = safyInfo.user.displayName;
    //   console.log("user display name", `"${user}"`);
    //   return (
    //     user === "Lindsay Dickson" ||
    //     user === "Emily Ullrich" ||
    //     user === "Matthew Cloven" ||
    //     user === "Kimberly Sworn" ||
    //     user === "Jenna Coleman" ||
    //     user === "Cameron Hiebert" ||
    //     modules.includes("Admin") ||
    //     modules.includes("Opeeka")
    //   );
    // } else return false;
  };

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  //GetFormsAndContainers
  useEffect(() => {
    getFormContainersAndVersions().then((response) => {
      if (response) {
        console.log("Forms and Containers", response);
        setFormsInfo(response);
      }
    });
  }, []);

  //GET OPEEKA TOKEN
  // useEffect(() => {
  //   if (safyInfo) modules = safyInfo.user.modules;
  //   if (validUsers()) {
  //     var myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  //     var urlencoded = new URLSearchParams();
  //     urlencoded.append("username", "safyapiuserprod@safy.org");
  //     urlencoded.append("password", "N!6Dc31ix@L%3jS");
  //     urlencoded.append("grant_type", "password");
  //     urlencoded.append("scope", "openid d3a1123b-2b73-4820-9c60-d42ed97a6280");
  //     urlencoded.append("client_id", "d3a1123b-2b73-4820-9c60-d42ed97a6280");
  //     urlencoded.append("response_type", "token");

  //     var requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: urlencoded,
  //       redirect: "follow",
  //     };

  //     fetch(
  //       "https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/B2C_1_ROPC_Auth_PCIS/oauth2/v2.0/token",
  //       requestOptions
  //     )
  //       .then((response) => response.text())
  //       .then((result) => {
  //         if (isMountedRef.current && result) {
  //           console.log("Opeeka Token", JSON.parse(result));

  //           setToken(JSON.parse(result));
  //         }
  //       })
  //       .catch((error) => console.log("error", error));
  //   }
  // }, []);

  // useEffect(() => {
  //   if (validUsers()) {
  //     getClientIdentifiers(contactID).then((response) => {
  //       if (response && isMountedRef.current) {
  //         const result = response
  //           .filter(
  //             (identifier) =>
  //               getFieldText(identifier.ccx_clientidentifiertype) ===
  //                 "186460001" && identifier.ccx_expdate === undefined
  //           )
  //           .sort((a, b) => {
  //             const aDate = getFieldDate(a.ccx_effdate);
  //             const bDate = getFieldDate(b.ccx_effdate);
  //             if (aDate > bDate) return 1;
  //             if (aDate < bDate) return -1;
  //             return 0;
  //           })
  //           .map((id) => ({
  //             id: id.ccx_name.split("|")[0],
  //             personIndex: id.ccx_name.split("|")[1],
  //           }))[0];

  //         setOpeekaPerson(result);
  //       }
  //     });
  //   }
  // }, []);

  //SEARCH FOR OPEKA USER BY CLIENT ID
  // useEffect(() => {
  //   if (token || reload) {
  //     console.log("Opeeka Searching for Person");
  //     const endpoint = "person/list-external";
  //     const body = JSON.stringify({
  //       searchFields: {
  //         externalId: contactID,
  //       },
  //       pageSize: 20,
  //       pageNumber: 1,
  //     });

  //     opeekaProxy(token.access_token, endpoint, body).then((response) => {
  //       console.log("Opeeka Person Search Response", response);

  //       if (response && response.result) {
  //         if (response.result.totalCount === 1) {
  //           setOpeekaPerson(response.result.peopleDataList[0]);
  //         }
  //         if (response.result.totalCount === 0) {
  //           setOpeekaPerson(null);
  //         }
  //         if (response.result.totalCount > 1) {
  //           alert(
  //             `There were ${response.result.totalCount} clients found in Opeeka for this client. Please contact SOAR Support`
  //           );
  //           setOpeekaPerson("Error");
  //         }
  //       }
  //     });
  //     setReload(false);
  //   }
  // }, [token, reload]);

  // useEffect(() => {
  //   if (opeekaPerson && opeekaPerson !== "Error") {
  //     const endpoint = "assessment/list-external";
  //     const body = JSON.stringify({
  //       searchFields: {
  //         personIndex: opeekaPerson.personIndex,
  //       },
  //       pageSize: 20,
  //       pageNumber: 1,
  //     });

  //     opeekaProxy(token.access_token, endpoint, body).then((response) => {
  //       if (response && response.result) {
  //         setOpData(response.result);
  //       }
  //     });
  //   }
  // }, [opeekaPerson]);

  // const openOpeekaAssessment = (assessmentID, personIndex, questionnaireID) => {
  //   const url = `https://demo-login.p-cis.com/people/details?assessmentID=${assessmentID}&personIndex=${personIndex}&questionnaireID=${questionnaireID}`;
  //   window.open(url, "Opeeka");
  // };

  // const openOpeekaClient = () => {
  //   const url = `https://app1.p-cis.com/people/details?personIndex=${opeekaPerson.personIndex}`;
  //   window.open(url, "Opeeka");
  // };

  // const createOpeekaClient = () => {
  //   if (clientProgram) {
  //     const endpoint = "person-external";
  //     const body = JSON.stringify({
  //       firstName: clientProgram["con.firstname"] || "",
  //       middleName: clientProgram["con.middlename"] || "",
  //       lastName: clientProgram["con.lastname"] || "",
  //       dateOfBirth: clientProgram["con.birthdate"]
  //         ? new Date(getFieldDate(clientProgram["con.birthdate"]))
  //         : null,
  //       genderID: 11,
  //       universalID: `${contactID}`,
  //       address1: "",
  //       address2: "",
  //       city: "",
  //       zip: "",
  //       countryStateId: 0,
  //       countryId: 0,
  //       personRaceEthnicities: [
  //         {
  //           raceEthnicityID: 11,
  //         },
  //       ],
  //       personHelpers: [
  //         {
  //           helperID: 17,
  //           isLead: true,
  //           startDate: new Date(),
  //         },
  //         {
  //           helperID: 14,
  //           isLead: false,
  //           startDate: new Date(),
  //         },
  //       ],
  //       personCollaborations: [
  //         {
  //           collaborationID: 4,
  //           enrollDate: new Date(getFieldName(clientProgram["ccx_admitdate"])),
  //           isPrimary: true,
  //         },
  //       ],
  //     });

  //     console.log("Opeeka Client DTO", body);

  //     opeekaProxy(token.access_token, endpoint, body).then((response) => {
  //       if (
  //         response &&
  //         response.result &&
  //         response.result.responseStatusCode === 1001
  //       ) {
  //         toast.success("Client Created in Opeeka");
  //       }
  //       setReload(true);
  //     });
  //   }
  // };

  // async function opeekaProxy(opeekatoken, endpoint, body) {
  //   var myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   myHeaders.append("Authorization", `Bearer ${opeekatoken}`);
  //   console.log("Opeeka Proxy Token", opeekatoken);

  //   var requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: body,
  //     redirect: "follow",
  //   };

  //   console.log("Fetching Opeeka Proxy");
  //   var data = await fetch(
  //     `https://safyportalapi.azurewebsites.net/api/opeeka/?uri=https://demo-api.p-cis.com/api/${endpoint}`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       console.log("Opeeka Proxy Result", JSON.parse(result));
  //       return JSON.parse(result);
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //       return error;
  //     });
  //   return data;
  // }

  return (
    <div>
      {carePlans ? (
        <CarePlans
          contactID={contactID}
          carePlans={carePlans}
          updateCarePlans={updateCarePlans}
          clientProgram={clientProgram}
        />
      ) : null}
      <div className=" p-2 mb-4">
        <div className="h3 mb-4">Assessments</div>
        {process.env.REACT_APP_ENVIRONMENT !== "Production" ||
        moment.utc().isSameOrAfter(moment.utc("May 8, 2023 20:00")) ? (
          <CSSRS2
            className="p-2 m-2"
            contactID={contactID}
            clientProgram={clientProgram}
          />
        ) : (
          <CSSRS className="p-2 m-2" contactID={contactID} />
        )}
        {assessmentsToShow?.map((item, index) => {
          return (
            <React.Fragment key={`Assessment.${index}`}>
              {getFormAssessment(
                item,
                contactID,
                clientProgram,
                "cpass",
                formsInfo
              )}
            </React.Fragment>
          );
        })}
        {/* {opeekaPerson && opeekaPerson.personIndex && (
          <div className="btn btn-safy-info" onClick={openOpeekaClient}>
            Open Client in Opeeka
          </div>
        )} */}
        {/* {opeekaPerson === null && (
          <div className="btn btn-success" onClick={createOpeekaClient}>
            Create Client in Opeeka
          </div>
        )} */}
        {/* {opData && (
          <>
            <div className="h6 mt-4">Opeeka Assessments</div>
            <div>Count: {opData.totalCount}</div>
            {opData &&
              opData.assessmentDataList &&
              opData.assessmentDataList.length > 0 &&
              opData.assessmentDataList.map((assessment, index) => (
                <div
                  className="border p-2 mb-4 card-safy"
                  onClick={() =>
                    openOpeekaAssessment(
                      assessment.assessmentID,
                      assessment.personIndex,
                      assessment.questionnaireID
                    )
                  }
                  key={`Opeeka.${index}`}
                >
                  <div>{`questionnaire ID: ${assessment.questionnaireID}`}</div>
                  <div>{`Assessment ID: ${assessment.assessmentID}`}</div>
                  <div>{`Date: ${new Date(
                    assessment.dateTaken
                  ).toLocaleString()}`}</div>
                  <div>{`Type: ${assessment.assessmentReason}`}</div>
                  <div>{`Time Period: ${assessment.timePeriod}`}</div>
                  <div>{`Status: ${assessment.assessmentStatus}`}</div>
                </div>
              ))}
          </>
        )} */}
      </div>
    </div>
  );
};

export default Assessments;
